<ng-container *ngIf="control && control.invalid && (!control.pristine || control.touched)">
    <span *ngFor="let error of control.errors | keys" [ngSwitch]="error">
        <ng-container
                *ngSwitchCase="'atLeastOneDriver'">Na polisie musi znaleźć się przynajmniej jeden kierowca. </ng-container>
        <ng-container *ngSwitchCase="'required'">Pole jest wymagane. </ng-container>
        <ng-container *ngSwitchCase="'patternError'">Format wpisanej wartości jest niepoprawny. </ng-container>
        <ng-container *ngSwitchCase="'min'">Minmalna wartość dla pola: {{control.errors[error]['min']}}. </ng-container>
        <ng-container *ngSwitchCase="'max'">Maksymalna wartość dla pola: {{control.errors[error]['max']}}. </ng-container>
        <ng-container *ngSwitchCase="'errorMessage'">{{control.errors[error]}} </ng-container>
        <ng-container *ngSwitchCase="'email'">Adres e-mail jest niepoprawny. </ng-container>
        <ng-container *ngSwitchCase="'phoneError'">Podany numer telefonu jest niepoprawny</ng-container>
        <ng-container *ngSwitchCase="'passwordError'">
            Hasło musi zawierać: <strong><span *ngFor="let errorKey of control.errors[error] | keys; let last = last">
            {{control.errors[error][errorKey]}} <span *ngIf="!last">, </span>
        </span></strong>
        </ng-container>
    </span>
</ng-container>
